document.addEventListener("DOMContentLoaded", function() {

  function updateStateField($countrySelect) {
    const $container = $countrySelect.closest('.nested-fields');
    const $stateContainer = $container.find('.state-field-container');
    const countryId = $countrySelect.val();

    const stateLabelHtml = '<label for="state">State</label>';

    if (countryId) {
      fetch(`/fetch_states?country_id=${countryId}`)
        .then(response => response.json())
        .then(states => {

          if (states.length > 0) {
            const selectHtml = `
              ${stateLabelHtml}
              <select name="${$stateContainer.find('select, input').attr('name')}" class="form-control consignee-state-select">
                <option value="">Select State</option>
                ${states.map(state => `<option value="${state[0]}">${state[0]}</option>`).join('')}
              </select>
            `;
            $stateContainer.html(selectHtml);
          } else {
            const inputHtml = `
              ${stateLabelHtml}
              <input type="text" name="${$stateContainer.find('select, input').attr('name')}" placeholder="Enter State Manually" class="form-control consignee-state-manual" />
            `;
            $stateContainer.html(inputHtml);
          }
        });
    } else {
      const inputHtml = `
        ${stateLabelHtml}
        <input type="text" name="${$stateContainer.find('select, input').attr('name')}" placeholder="Enter State Manually" class="form-control consignee-state-manual" />
      `;
      $stateContainer.html(inputHtml);
    }
  }

  $(document).on('change', '.consignee-address-type-select', function() {
    const $residenceField = $(this).closest('.nested-fields').find('.consignee-residence-type-field');
    if ($(this).val() === "Residential") {
      $residenceField.show();
    } else {
      $residenceField.hide();
    }
  });

  $(document).on('change', '.consignee-country-select', function() {
    updateStateField($(this));
  });
});